import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableSchedulePopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "schedulepopup" */
        './SchedulePopup'
      )
  )
);

interface Props {
  deviation: PapiDeviation;
  requestClose: () => void;
}

const LazySchedulePopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazySchedulePopup">
    <Suspense fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}>
      <LoadableSchedulePopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazySchedulePopup.displayName = 'LazyScheduleSubmitPopup';

export default LazySchedulePopup;
